import Client from "@/http/client";
import { HotelWeatherDto } from "@/http/dto/weather";

export class Weather {
  static get(hotelObjectId: string, refresh = false) {
    return Client.get<HotelWeatherDto>(`/v2/${hotelObjectId}/weather`, { refresh });
  }
}
